import { CommonModule, NgOptimizedImage } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'

// Components
import { ComponentsModule } from '../../components/components.module'
import { LocalizedDatePipe } from '../../shared/pipes/localized-date.pipe'
import { SharedModule } from '../../shared/shared.module'
import { ArticlesModule } from '../articles/articles.module'
import { EditionComponentsModule } from '../magazines-and-journals/magazines-and-journals-detail-page/components/edition-components.module'
import { CaseLawSectionComponent } from './edition-overview/components/case-law-section/case-law-section.component'
import { EditionHeaderComponent } from './edition-overview/components/edition-header/edition-header.component'
import { NavigationComponent } from './edition-overview/components/navigation/navigation.component'
import { PreviousEditionsSectionComponent } from './edition-overview/components/previous-editions-section/previous-editions-section.component'
import { SignalsSectionComponent } from './edition-overview/components/signals-section/signals-section.component'
import { EditionOverviewComponent } from './edition-overview/edition-overview.component'
import { EditionsRoutingModule } from './editions-routing.module'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ComponentsModule,
    EditionsRoutingModule,
    ArticlesModule,
    NgOptimizedImage,
    SharedModule,
    ReactiveFormsModule,
    EditionComponentsModule,
    LocalizedDatePipe,
    TranslatePipe,
    EditionHeaderComponent,
    EditionOverviewComponent,
    PreviousEditionsSectionComponent,
    SignalsSectionComponent,
    CaseLawSectionComponent,
    NavigationComponent,
  ],
  exports: [EditionOverviewComponent],
})
export class EditionsModule {}
